import north1 from "./1.png";
import north2 from "./2.png";
import north3 from "./3.png";

const North = [north1, north2, north3];

export default North;
